import MarketplaceHomePublicContainer from './marketplace-home-public-container';

export default MarketplaceHomePublicContainer;